import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { saveStorageAction } from 'actions/rating/saveStorageAction'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

/**
 * При асинхронных операция store.subscribe не запускается после окончание изменения state
 */
export const useSaveStorage = () => {
  const dispatch = useDispatch()
  const { votedPhotos, currentQueuePhotos } = useShallowEqualSelector(
    ({ photoRatingNext: { votedPhotos, currentQueuePhotos } }) => ({
      votedPhotos,
      currentQueuePhotos,
    })
  )

  useEffect(() => {
    dispatch(saveStorageAction())
  }, [dispatch, votedPhotos, currentQueuePhotos])
}
